<template>
    <Order :key="$route.params.id" :needFilter="false" :specificApiRequest="params" />
</template>

<script>
import Order from "@components/orders/Order.vue";
import { mapGetters } from "vuex";

export default {
    components: {
        Order,
    },

    computed: {
        ...mapGetters(["REFERENCE_PROPERTIES"]),

        params() {
            return {
                reference_order_status_id: Number(this.$route.params.id),
            };
        },
    },

    metaInfo() {
        return {
            title: `Таблица запросов "${
                this.REFERENCE_PROPERTIES && this.REFERENCE_PROPERTIES[Number(this.$route.params.id)] && this.REFERENCE_PROPERTIES[Number(this.$route.params.id)].text
            }"`,
        };
    }
};
</script>
